import { type AssociationsV2, associationsV2Transformer, type Configuration, type TokenToSave } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';

export class FuscaIdentificationTokenRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public createTokens = (newTokens: TokenToSave[]): Promise<void> => {
    const bodyRequest = newTokens.map((token) => ({
      id: token.id,
      alias: token.alias,
    }));
    const requestData: IRequest = {
      endpoint: '/identification-tokens',
      method: HttpMethod.POST,
      body: JSON.stringify(bodyRequest),
    };
    return this.requester.request(requestData).then();
  };

  public getTokenAssociationsV2 = (): Promise<AssociationsV2> => {
    const requestData: IRequest = {
      endpoint: '/identification-tokens?isLinkedToDriver=true',
      method: HttpMethod.GET,
    };
    return this.requester.request(requestData).then((response) => {
      return associationsV2Transformer(response.data);
    });
  };
}

export default FuscaIdentificationTokenRequester;
